import React, { Component } from 'react';
import is from 'is_js';
import PropTypes from 'prop-types';

import { ConfirmDialog } from 'omni-common-ui';

export class UnsavedChangesWarning extends Component {
  componentWillReceiveProps(nextProps) {
    const { isOpen, isSaving, onSaved } = this.props;
    if (isOpen && isSaving && ! nextProps.isSaving) {
      onSaved && onSaved();
    }
  }

  _getDialogText() {
    return this.props.dialogText || 'Do you want to save your changes?';
  }

  _getPrimaryButtonLabel() {
    return this.props.primaryButtonLabel || 'Save';
  }

  _getSecondaryButtonLabel() {
    return this.props.secondaryButtonLabel || 'Discard';
  }

  render() {
    const props = this.props;
    return <ConfirmDialog isOpen={is.function(props.isOpen) ?
          props.isOpen() : !! props.isOpen}
        isLoading={is.function(props.isSaving) ?
          props.isSaving() : !! props.isSaving}
        primaryButtonContent={this._getPrimaryButtonLabel()}
        secondaryButtonContent={this._getSecondaryButtonLabel()}
        onPrimaryClick={() =>
          props.onSaveClicked && props.onSaveClicked()}
        onSecondaryClick={() =>
          props.onDiscardClicked && props.onDiscardClicked()}
        onRequestClose={() =>
          props.onCloseClicked && props.onCloseClicked()}>
      <span>{this._getDialogText()}</span>
    </ConfirmDialog>;
  }
}

UnsavedChangesWarning.propTypes = {
  dialogText: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  isOpen: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  isSaving: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  onDiscardClicked: PropTypes.func,
  onCloseClicked: PropTypes.func,
  onSaveClicked: PropTypes.func,
  onSaved: PropTypes.func,
};

export default UnsavedChangesWarning;



// WEBPACK FOOTER //
// ./components/UnsavedChangesWarning/index.jsx